class Intervals{
    constructor(intervalsPerHour, week, activatedRules){
        this.week = week;
        this.intervalsPerHour = intervalsPerHour;
        this.intervalValue = (intervalsPerHour == 2 ? 30:15);
        this.activatedRules = activatedRules;
        this.aZeitenFeiertag = (activatedRules.AZeitenFT = 1);
        this.intervalsPerWeek = {A: 0, B: 0, D: 0, C:0, P: 0, X:0};
        this.intervalsPerDay = {"mo": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "di": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "mi": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "do": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "fr": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "sa": {A: 0, B: 0, D: 0, C:0, P: 0, X:0},
            "so": {A: 0, B: 0, D: 0, C:0, P: 0, X:0}};
        this.oldIntervals = {"mo": {A: 0, B: 0},
            "di": {A: 0, B: 0},
            "mi": {A: 0, B: 0},
            "do": {A: 0, B: 0},
            "fr": {A: 0, B: 0},
            "sa": {A: 0, B: 0},
            "so": {A: 0, B: 0}};
        this.weekdays = ["mo", "di", "mi", "do", "fr", "sa", "so"];
        this.isCalculated = false;
        this.breakDeduction = 0;
        this.breakDeductionPerDay = {"mo": 0,
            "di": 0,
            "mi": 0,
            "do": 0,
            "fr": 0,
            "sa": 0,
            "so": 0};
    }

    getIntervalsPerDay(){
        if(!this.isCalculated) {
            this._calcIntervals();
        }
        return this.intervalsPerDay;
    }

    getIntervalsPerWeek(){
        if(!this.isCalculated) {
            this._calcIntervals();
        }
        return this.intervalsPerWeek;
    }

    getOldIntervals(){
        if(!this.isCalculated) {
            this._calcIntervals();
        }
        return this.oldIntervals;
    }

    getAbzug(){
        if(!this.isCalculated) {
            this._calcIntervals();
        }
        return this.breakDeduction;
    }

    setIntervals(){
        let wishes = ["A", "B", "P"];
        for(let i = 0; i < this.weekdays.length; i++ ){
            let weekday = this.weekdays[i];
            for(let j = 0; j < wishes.length; j++ ){
                let wish = wishes[j];
                let value = 0;
                if(wish === "P"){
                    value = this.intervalsPerDay[weekday][wish] + this.breakDeductionPerDay[weekday];
                }else{
                    value = this.intervalsPerDay[weekday][wish];
                }
                let day = i + 1;
                document.getElementById("w" + this.week + "_" + day + wish).value = value / this.intervalsPerHour;
            }
        }
    }

    _calcIntervals(){
        let oldWishes = ["A", "B"];
        let intervalleProTag = 24 * this.intervalsPerHour;
        let minimumBreakTimeRule = new MinimumBreakTimeRules(this.activatedRules);

        for(let i = 0; i < this.weekdays.length; i++){
            let dayNr = i +1;
            let weekday = this.weekdays[i];

            this._calcIntervalsPerDay(dayNr, intervalleProTag, weekday);
            this._calcBreakDeduction(minimumBreakTimeRule, weekday);
            this._calcOldIntervals(oldWishes, i, dayNr);
        }

        this.isCalculated = true;
    }

    _calcOldIntervals(oldWishes, i, dayNr) {
        for (let k = 0; k < oldWishes.length; k++) {
            this.oldIntervals[this.weekdays[i]][oldWishes[k]] = document.getElementById("w" + this.week + "_" + dayNr + oldWishes[k]).value;
        }
    }

    _calcIntervalsPerDay(dayNr, intervalleProTag, weekday) {
        if (!this._isFeiertag(dayNr, this.aZeitenFeiertag) && !this._isAbsence(dayNr)) {
            for (let j = 0; j <= (intervalleProTag - 1); j++) {
                let wish = document.getElementById("w" + this.week + "_" + weekday + j).value;
                this.intervalsPerDay[weekday][wish]++;
                this.intervalsPerWeek[wish]++;
            }
        }

    }

     _calcBreakDeduction(minimumBreakTimeRule, weekday) {
        let dayBreakDeduction = minimumBreakTimeRule.calcSubtractionFromHourRules(this.intervalsPerDay[weekday]["A"] * this.intervalValue, this.intervalsPerDay[weekday]["P"] * this.intervalValue);
        this.breakDeduction += dayBreakDeduction;
        this.breakDeductionPerDay[weekday] = dayBreakDeduction / this.intervalValue;
    }

    _isFeiertag(dayNr) {
        let tagid = document.getElementById("w" + this.week + "_tagname" + dayNr);
        let tagstatus = tagid.getAttribute('data-tagstatus');
        if (this.aZeitenFeiertag === 1) {
            if (tagstatus === "isHoliday") {
                return true;
            }
        }
        return false;
    }

    _isAbsence(dayNr) {
        let tagid = document.getElementById("w" + this.week + "_tagname" + dayNr);
        let tagstatus = tagid.getAttribute('data-tagstatus');

        return tagstatus === "isAbsence";
    }

}